import * as engagementModalBehavior from '~/modules/no_engagement/stores/engagement-modal-behavior'
import * as engagementModal from '~/modules/no_engagement/stores/engagement-modal'
import { initSubscribers } from '~/modules/no_engagement/stores/store-action-subscribers'

export default (context) => {
  context.store.registerModule('engagementModalBehavior', engagementModalBehavior)
  context.store.registerModule('engagementModal', engagementModal)
  initSubscribers(context)
}
